module.exports = "<div class=\"search\" *ngIf=\"show\">\n  <input class=\"w-input searchbar\" type=\"text\" name=\"search\" [(ngModel)]=\"keywords\" (ngModelChange)=\"updateFilter()\" placeholder=\"{{ 'Zoek in bibliotheek'| translate }}\">\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/components/searchbar/searchbar.component.html
// module id = ../../../../../src/app/components/searchbar/searchbar.component.html
// module chunks = main